import { Link, useInRouterContext } from 'react-router-dom'

import { usePublicProfilesEnabled } from '../../hooks/useFeatures'
import { profilePath } from '../../lib/publicProfile'

/**
 * A name or an avatar that opens the learner's public profile (V5-w,
 * `/u/:userId`). It draws exactly what it wraps — no underline, no new
 * colour — so a feed card, a leaderboard row or a team member looks as it
 * did; only a tap now goes somewhere.
 *
 * A plain span — no navigation — while public profiles are switched off
 * (`me_profile.features.publicProfilesEnabled`, V5-w-flags; production
 * until stage 3), and outside a router (a component rendered on its own,
 * as some tests do).
 */
export default function UserLink({ userId, className = '', label, children }) {
  const inRouter = useInRouterContext()
  const enabled = usePublicProfilesEnabled()
  if (!userId || !inRouter || !enabled) return <span className={className}>{children}</span>
  return (
    <Link to={profilePath(userId)} className={className} aria-label={label} data-profile-link={userId}>
      {children}
    </Link>
  )
}
